import { render, staticRenderFns } from "./CompaniesCatalog.vue?vue&type=template&id=2ba2dfc3"
import script from "./CompaniesCatalog.vue?vue&type=script&lang=js"
export * from "./CompaniesCatalog.vue?vue&type=script&lang=js"
import style0 from "./CompaniesCatalog.vue?vue&type=style&index=0&id=2ba2dfc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports